import React, { useEffect, useState } from 'react';
import { Pagination } from 'react-bootstrap';
import ProductTypeCard from './ProductTypeCard';

const ProductTypeList = ({ products, loading, onAddToFavorites, onAddToCart }) => {

    const itemsPerPage = 4; // 6 columns * 2 rows
    const totalPages = Math.ceil(products?.length / itemsPerPage);
    const [currentPage, setCurrentPage] = useState(1);

    // Get products for the current page
    const indexOfLastProduct = currentPage * itemsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
    const currentProducts = products.slice(indexOfFirstProduct, indexOfLastProduct);

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <>
            {/* Products Grid */}
            <div className="row g-1">
                {currentProducts.map((product, index) => (
                    <div key={index} className="col-md-3 mb-0">
                        <ProductTypeCard
                            product={product}
                            onAddToFavorites={onAddToFavorites}
                            onAddToCart={onAddToCart}
                        />
                    </div>
                ))}
            </div>

            <CustomPagination
                totalPages={totalPages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />

        </>
    );
};

export default ProductTypeList;

const CustomPagination = ({ totalPages, currentPage, setCurrentPage }) => {
  const [hoveredButton, setHoveredButton] = useState(null);

  const generatePageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5; // Controls how many page numbers are visible

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
      }
    }

    return pages;
  };

  // Handle hover events
  const handleMouseEnter = (button) => {
    setHoveredButton(button);
  };

  const handleMouseLeave = () => {
    setHoveredButton(null);
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "1.3rem" }}>
      <button
        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        disabled={currentPage === 1}
        className="btn mx-1"
        onMouseEnter={() => handleMouseEnter("previous")}
        onMouseLeave={handleMouseLeave}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          backgroundColor:
            currentPage === 1
              ? "#ccc"
              : hoveredButton === "previous"
                ? "#fff" // White background on hover
                : "#8d070e",
          color: currentPage === 1 ? "#666" : hoveredButton === "previous" ? "#8d070e" : "#fff", // Red text on hover
          border: `1px solid ${currentPage === 1 ? "#ccc" : hoveredButton === "previous" ? "#8d070e" : "#8d070e"}`,
          fontWeight: "bold",
          cursor: currentPage === 1 ? "not-allowed" : "pointer",
        }}
      >
        <i className="bi bi-chevron-left"></i> Previous
      </button>


      {/* Page Numbers */}
      {generatePageNumbers().map((page, index) =>
        page === "..." ? (
          <span key={index} className="mx-2 text-muted">
            {page}
          </span>
        ) : (
          <button
            key={page}
            onClick={() => setCurrentPage(page)}
            className="btn mx-1"
            onMouseEnter={() => handleMouseEnter(page)}
            onMouseLeave={handleMouseLeave}
            style={{
              backgroundColor: page === currentPage ? "#8d070e" : hoveredButton === page ? "#8d070e" : "transparent", // Color change on hover
              color: page === currentPage ? "#fff" : hoveredButton === page ? "#fff" : "#8d070e", // Color change on hover
              border: `1px solid ${page === currentPage ? "#8d070e" : hoveredButton === page ? "#6f4500" : "#8d070e"}`,
              fontWeight: "bold",
            }}
          >
            {page}
          </button>
        )
      )}

      <button
        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
        disabled={currentPage === totalPages}
        className="btn mx-1"
        onMouseEnter={() => handleMouseEnter("next")}
        onMouseLeave={handleMouseLeave}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          backgroundColor:
            currentPage === totalPages
              ? "#ccc"
              : hoveredButton === "next"
                ? "#fff" // White background on hover
                : "#8d070e",
          color: currentPage === totalPages ? "#666" : hoveredButton === "next" ? "#8d070e" : "#fff", // Red text on hover
          border: `1px solid ${currentPage === totalPages ? "#ccc" : hoveredButton === "next" ? "#8d070e" : "#8d070e"}`,
          fontWeight: "bold",
          cursor: currentPage === totalPages ? "not-allowed" : "pointer",
        }}
      >
        Next <i className="bi bi-chevron-right"></i>
      </button>
    </div>
  );
};